import { Action, AsyncAction } from '../../../types/actions';
import type { IWatermarkSet, CreateWatermarkSet } from '../../../types/watermarks.types';
import {
	GetWatermark,
	GetWatermarksByChannel,
	CreateWatermark,
	UpdateWatermark,
	DeleteWatermark,
} from '../../../connection/watermarks';

export const LOAD_CHANNEL_WATERMARKS = 'LOAD_CHANNEL_WATERMARKS';
export function loadChannelWatermarks(channel: number, token: string): AsyncAction {
	return {
		type: LOAD_CHANNEL_WATERMARKS,
		promise: GetWatermarksByChannel(channel, token),
	};
}

export const LOAD_WATERMARK = 'LOAD_WATERMARK';
export function loadWatermark(channel: number, uuid: string, token: string): AsyncAction {
	return {
		type: LOAD_WATERMARK,
		promise: GetWatermark(channel, uuid, token),
	};
}

export const CREATE_WATERMARK = 'CREATE_WATERMARK';
export function createWatermark(watermark: CreateWatermarkSet, token: string): AsyncAction {
	return {
		type: CREATE_WATERMARK,
		promise: CreateWatermark(watermark, token),
	};
}

export const UPDATE_WATERMARK = 'UPDATE_WATERMARK';
export function updateWatermark(watermark: IWatermarkSet, token: string): AsyncAction {
	return {
		type: UPDATE_WATERMARK,
		promise: UpdateWatermark(watermark, token),
	};
}

export const DELETE_WATERMARK = 'DELETE_WATERMARK';
export function deleteWatermark(channel: number, uuid: string, token: string): AsyncAction {
	return {
		type: DELETE_WATERMARK,
		promise: DeleteWatermark(channel, uuid, token),
		meta: { uuid },
	};
}

export const REMOVE_WATERMARK = 'REMOVE_WATERMARK';
export function removeWatermark(uuid: string): Action {
	return {
		type: REMOVE_WATERMARK,
		payload: uuid,
	};
}

export const SET_CURRENT_WATERMARK = 'SET_CURRENT_WATERMARK';
export function setCurrentWatermark(watermark: IWatermarkSet): Action {
	return {
		type: SET_CURRENT_WATERMARK,
		payload: watermark,
	};
}

export const CLEAR_CURRENT_WATERMARK = 'CLEAR_CURRENT_WATERMARK';
export function clearCurrentWatermark(): Action {
	return {
		type: CLEAR_CURRENT_WATERMARK,
		payload: null,
	};
}

export const RESET_WATERMARKS_REDUCER = 'RESET_WATERMARKS_REDUCER';
export function resetWatermarksReducer(): Action {
	return {
		type: RESET_WATERMARKS_REDUCER,
		payload: null,
	};
}
